const nonRdcQuestions=[
    {
    label:"Any other information for the referral",
    controlType:"text area",
    options:[]
    },
]

export default nonRdcQuestions